import { ref } from "vue";
import { envOverrides as envOverrides$1 } from "@sennder/federated-module-loader";
const overrides = ref(/* @__PURE__ */ new Map());
const prefix = "ENV_OVERRIDE:";
const getUrlOverrides = (search) => {
  const params = new URLSearchParams(search);
  return [...params.entries()].reduce((acc, [name, override]) => {
    if (name.startsWith(prefix)) {
      acc.push({
        name: name.slice(prefix.length),
        override
      });
    }
    return acc;
  }, []);
};
const load = () => {
  const storedEnvOverrides = JSON.parse(
    sessionStorage.getItem("envOverrides") || "[]"
  );
  const overrides2 = [
    ...storedEnvOverrides.map(([name, override]) => ({
      name,
      override
    })),
    ...getUrlOverrides(window.location.search)
  ];
  overrides2.forEach(({ name, override }) => {
    add(name, override);
  });
};
const add = (npmName, branch) => {
  envOverrides$1.addOverride(npmName, branch);
  envOverrides.overrides.value.set(npmName, branch);
  sessionStorage.setItem(
    "envOverrides",
    JSON.stringify(Array.from(envOverrides.overrides.value))
  );
};
const remove = (npmName) => {
  envOverrides$1.removeOverride(npmName);
  envOverrides.overrides.value.delete(npmName);
  sessionStorage.setItem(
    "envOverrides",
    JSON.stringify(Array.from(envOverrides.overrides.value))
  );
};
const envOverrides = {
  load,
  overrides,
  add,
  remove
};
export {
  envOverrides,
  getUrlOverrides,
  prefix
};
